import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface Occurrence {
  id: string;
  type: string;
  orderNumber: string;
  priority: string;
  status: string;
  description: string;
  createdAt: string;
}

const priorityLabels: Record<string, { label: string; color: string }> = {
  LOW: { label: 'Baixa', color: 'bg-gray-100 text-gray-700' },
  MEDIUM: { label: 'Media', color: 'bg-yellow-100 text-yellow-700' },
  HIGH: { label: 'Alta', color: 'bg-orange-100 text-orange-700' },
  CRITICAL: { label: 'Critica', color: 'bg-red-100 text-red-700' },
};

const occurrenceStatusLabels: Record<string, { label: string; color: string }> = {
  OPEN: { label: 'Aberta', color: 'bg-blue-100 text-blue-700' },
  IN_PROGRESS: { label: 'Em Andamento', color: 'bg-yellow-100 text-yellow-700' },
  RESOLVED: { label: 'Resolvida', color: 'bg-green-100 text-green-700' },
  CLOSED: { label: 'Fechada', color: 'bg-gray-100 text-gray-700' },
};

export default function OccurrencesPage() {
  const [occurrences, setOccurrences] = useState<Occurrence[]>([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    api.get('/occurrences').then((r) => {
      setOccurrences(r.data.data || r.data);
      setLoadingData(false);
    });
  }, []);

  return loadingData ? (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
    </div>
  ) : (
    <div className="bg-white rounded-xl shadow-sm border border-dark-100 overflow-hidden">
      <table className="w-full">
        <thead className="bg-dark-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Tipo</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Pedido</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Prioridade</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Descricao</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Data</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-dark-100">
          {occurrences.map((item, index) => (
            <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-dark-50/50'}>
              <td className="px-6 py-4 text-sm font-medium text-dark-900">{item.type}</td>
              <td className="px-6 py-4 text-sm font-medium text-primary-600">{item.orderNumber || '-'}</td>
              <td className="px-6 py-4">
                <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${priorityLabels[item.priority]?.color || 'bg-gray-100 text-gray-700'}`}>
                  {priorityLabels[item.priority]?.label || item.priority}
                </span>
              </td>
              <td className="px-6 py-4">
                <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${occurrenceStatusLabels[item.status]?.color || 'bg-gray-100 text-gray-700'}`}>
                  {occurrenceStatusLabels[item.status]?.label || item.status}
                </span>
              </td>
              <td className="px-6 py-4 text-sm text-dark-600 max-w-xs truncate">{item.description || '-'}</td>
              <td className="px-6 py-4 text-sm text-dark-500">
                {new Date(item.createdAt).toLocaleDateString('pt-BR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {occurrences.length === 0 && (
        <div className="text-center py-12 text-dark-500">Nenhuma ocorrencia encontrada</div>
      )}
    </div>
  );
}
